import React from 'react'
import { Route, Routes, Outlet, Navigate } from 'react-router-dom';
import { userRoutes, authRoutes } from './allRoutes'

import Layout from "../components/verticalLayout/index";
import NoAuthLayout from "../components/NonAuthLayout";
import SnowEffect from 'components/SnowEffect';
import { isSessionValid } from 'helpers/session';

function createPublicRoutes() {
	return authRoutes.map((item, key) => {
		return (
			<Route key={key} path={item.path} element={item.component} />
		);
	});
}

function createPrivateRoutes() {
	return userRoutes.map((item, key) => {
		return (
			<Route key={key} element={<ProtectedRoute />}>
				<Route path={item.path} element={item.component} />
			</Route>
		);
	});
}

const ProtectedRoute = () => {
	const login = localStorage.getItem("username");
	var isAuthenticated = false;
	if (login) {
		isAuthenticated = true
	} else {
		isAuthenticated = false
	}

	if (!isAuthenticated) {
		localStorage.removeItem('username')
		localStorage.removeItem('role')
		localStorage.removeItem('token')
		return <Navigate to="/auth/login" />;
	}

	// Boshqa oynada (tab) boshqa akkaunt kirgan bo'lsa, bu oyna o'sha sessiyaga
	// tegishli emas. Umumiy localStorage'ga tegilmaydi -- u yangi akkauntniki.
	if (!isSessionValid()) {
		return <Navigate to="/auth/login" />;
	}

	return <Outlet />;
};

const Index = () => {
	return (
		<Routes>
			<Route element={<NoAuthLayout />}>
				{createPublicRoutes()}
			</Route>

			<Route element={<Layout />}>
				{createPrivateRoutes()}
			</Route>

			<Route element={<Layout />}>
				<Route path="*" element={<Navigate to="/auth/login" replace />} />
			</Route>

		</Routes>
	)
}

export default Index;